import { Stack, styled } from '@mui/material';
import React from 'react';

import { Screen } from '@/components/Layout/Screen';

import { getAssetPath } from '@/constants/configs';

export const Logo = styled(
  (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
    <img src={getAssetPath('/logo-with-text.svg')} {...props} />
  ),
)(({ theme }) => ({
  width: 109,
  marginLeft: 'auto',
  marginRight: 'auto',
  marginBottom: theme.spacing(1),
}));

export const StyledScreen = styled(Screen)(({ theme }) => ({
  display: 'flex',
  paddingLeft: 0,
  paddingRight: 0,
  paddingBottom: theme.spacing(3),

  '.MuiContainer-root': {
    padding: 0,
    margin: 0,
    width: '100%',
    maxWidth: 'unset',
  },
}));

export const AccountTypeContainer = styled(Stack)(({ theme }) => ({
  gap: 0,
  marginTop: theme.spacing(4),
  flex: 1,
  flexDirection: 'column',
  minHeight: 0,
  height: '100%',
  overflowY: 'auto',
  width: '100%',
}));
